import { gql } from '@apollo/client';

/**
 * Unsubscribe the customer an email link's token identifies, without signing in.
 * everything=false (the default) stops offers and marketing emails only;
 * everything=true also stops the tips emails. Resolves false for an unknown token.
 */
export const UNSUBSCRIBE_BY_TOKEN = gql`
  mutation UnsubscribeByToken($token: String!, $everything: Boolean) {
    unsubscribeByToken(token: $token, everything: $everything)
  }
`;

export interface UnsubscribeByTokenData {
  unsubscribeByToken: boolean;
}

export interface UnsubscribeByTokenVars {
  token: string;
  everything?: boolean;
}
